module.exports = __webpack_public_path__ + "img/maison-small.2f51c6fc.svg";